import { Form, Input } from "antd";
import { FC } from "react";
import { TextInputProps } from "../models/text_input_props";

const TextInput: FC<TextInputProps> = ({ placeholder, value, onChange, password, prefix, name, rules, dependencies, externalClass, label, ...props }) => {

    const InputComponent = password ? Input.Password : Input;
    return (
        <div className={`${externalClass}`}>
            <label htmlFor={name} className="form-label">
                {label}
            </label>
            <Form.Item
                name={name}
                rules={rules}
                dependencies={dependencies}
            >
                <InputComponent
                    {...props}
                    className="form-control"
                    value={value}
                    prefix={prefix}
                    onChange={onChange}
                    placeholder={placeholder}
                />
            </Form.Item>
        </div>
    );
};

export { TextInput };
